import { useEffect } from 'react';
import Header from './Header'
import Details from './Details'
import BillDetails from './BillDetails'
import OrderSummary from './OrderSummary'
import { useLabOrderDetailsStore } from '../../../stores'

const LabOrderDetailsInformation = () => {
  const { order, setIsAdmin, setLineItems } = useLabOrderDetailsStore();

  useEffect(() => {
    if (order) {
      setIsAdmin(order?.meta?.currentUserIsAdmin || false);
      setLineItems(order?.included || []);
    }
  }, [order]);

  if (!order) return null
  
  const attributes = order?.data?.attributes;
  
  return (
    <div className="wrapper">
      <div className="container-order-block">
        <Header attributes={attributes} />
        <Details />
        <OrderSummary />
        <BillDetails />
      </div>
    </div>
  )
}

export default LabOrderDetailsInformation